const variantName = 'instagramWidgetV1'

export default {
  [variantName]: {
    // ?============================
    // ?======  Containers =========
    // ?============================

    container: {
      flexDirection: ['column', '', 'row'],
      justifyContent: 'center',
      alignItems: 'center'
    },

    iFrameContainer: {
      width: ['100%', '', '50%']
    },

    logoAndTextContainer: {
      flexDirection: ['', '', 'column'],
      width: ['100%', '', '50%'],
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem 2rem',
      // TODO: change a to a variantName and give it is own variant rather than nested
      svg: {
        width: '100px',
        height: '100px',
        path: {
          fill: 'black'
        }
      }
    },

    // ?============================
    // ?======  Text Content =======
    // ?============================

    textContent: {
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1rem 0.25rem 1rem 1rem',
      textAlign: ['', '', 'center']
    },
    title: {
      fontSize: '1.5rem',
      marginBottom: '1rem'
    },
    subtitle: {
      fontSize: '1.25rem'
    }
  }
}
